import '/assets/js/common.js';
import '/assets/css/_common.scss';
import '/assets/css/archive-news.scss';
import '/assets/css/english-news.scss';

// ===========================================
// スクロールストップイベント
// ===========================================
let newEvent = new $.Event("scrollstop"),
    timer;

function newEventTrigger(){

  if (timer) clearTimeout(timer);

  timer = setTimeout(function(){
    $(window).trigger(newEvent)
  }, 200);
}

$(window).on("scroll", newEventTrigger);


// ===========================================
// 記事をajaxで読みこみ
// ===========================================
$(function(){
  // ajaxで記事を取得する処理の関数。
  function ajaxLoad( year, word, company, category, paged ) {

    // 絞り込み条件に応じてテキストを出力する処理
    sortTextPrint( year, word, company, category );

    // function.phpに情報（年、ワード、会社、カテゴリー）を送信し、出力する記事の情報を取得する。
    $.ajax({
      type: 'POST',
      url: ajaxurl,
      data: {
        'action' : 'ajax_get_new_posts',
        'postType': 'english-news',
        'year' : year,
        'word' : word,
        'company' : company,
        'category' : category,
        'paged' : paged,
        'perPage': 10,
      },

      // 送信が成功した場合に実行される関数。
      success: function( response ){
        let result_html = '';

        if( response === '[]' ) {
          // 失敗した場合の処理
          noMoreArticles = true;
          result_html = '<div class="noArticle">お探しの記事はありません。</div>';
        } else {
          // 成功した場合の処理

          // phpから送られてきた配列をjsonに変換。
          let jsonData = JSON.parse( response );

          // jsonをもとに、出力するhtmlを生成。
          result_html = '<ul class="newsList">';
              jsonData.forEach(function(data){
                let cats = '',
                    coms = '';

                if( data['categorys'] ) {
                  data['categorys'].forEach(function(category){
                    cats = cats +
                              '<div class="news__postTagItem">' +
                                category['name'] +
                              '</div>';
                  });
                }

                data['companys'].forEach(function(companyLogo){
                  if( companyLogo ) {
                    coms = coms +
                          '<div class="news__postComItem">' +
                            '<img src="' + companyLogo + '">' +
                          '</div>';
                  }
                });

                result_html = result_html +
                  '<li class="newsList__item">' +
                    '<a href="' + data['permalink'] + '" ' + data['targetStatus'] + ' class="newsList__itemLink">' +
                      '<div class="news__postMeta">' +
                        '<div class="news__postDate">' + data['post_date'] + '</div>' +
                        '<div class="news__postTag">' + cats + '</div>' +
                        '<div class="news__postCom">' + coms + '</div>' +
                      '</div>' +
                      '<h3 class="news__postTitle">' + data['post_title'] + data['pdfIcon'] + '</h3>' +
                    '</a>' +
                  '</li>';
              });
              result_html = result_html + '</ul>';
        }

        // ページ送りをした場合は、出力するhtmlを末端に追加し、
        // 絞り込み条件を変更した場合は、まっさらな状態でhtmlを出力する。
        if( paged > beforePaged ) {
          // ページ送りをした場合。
          listArea.append( result_html );

          setTimeout(function () {
            listArea.find('.newsList:not(.active)').addClass('active');
          }, 50);
        } else {
          // 絞り込み条件を変更した場合。
          listArea.find('.newsList.active').removeClass('active');

          setTimeout(function () {
            listArea.html( result_html );
          }, 300);

          setTimeout(function () {
            listArea.find('.newsList:not(.active)').addClass('active');
          }, 350);
        }
        setTimeout(function () {
          listArea.find('.newsList:not(.active)').each(function(){
            $(this).addClass('active');
          });
        }, 1300);
        beforePaged = paged;
      }
    });
    return false;
  }

  // 絞り込み条件に応じてテキストを出力する処理の関数
  function sortTextPrint( year, word, company, category ) {

    if( year !== 'undefined' ) {
      sortText.html('「' + year + '年」の記事一覧');
      sortText.addClass('active');
    } else if( word !== 'undefined' ) {
      let ptintTxt = '';

      if(
        word.includes(' ') ||
        word.includes('　')
      ) {
        word = word.replace(/　/g, ' ')
      }
      word = word.split(' ');
      word = word.filter(function(v){
        return ! [''].includes(v);
      });

      word.forEach(function( wordItem ){
        ptintTxt = ptintTxt + '「' + wordItem + '」';
      });

      sortText.html( ptintTxt + 'を含む記事一覧');
      sortText.addClass('active');
    } else if(
      company !== 'undefined' ||
      category !== 'undefined'
    ) {
      const companys = company.split(', '),
            categorys  = category.split(', ');
      let companysTxts = '',
          categorysTxts = '';

      companys.forEach(function( companySlug ) {
        const companysTxt = $('input[name="currentCom"][value="' + companySlug + '"]').attr('data-name');

        if( companysTxt ) {
          companysTxts = companysTxts + '「' + companysTxt + '」';
        }
      });

      categorys.forEach(function( categorySlug ) {
        const categorysTxt = $('input[name="currentCat"][value="' + categorySlug + '"]').attr('data-name');

        if( categorysTxt ) {
          categorysTxts = categorysTxts + '「' + categorysTxt + '」';
        }

        if( categorySlug === 'ir情報' ) {
          categorysTxts = categorysTxts + '「IR情報」';
        }
      });

      sortText.html(companysTxts + categorysTxts + 'が含まれる記事一覧');
      sortText.addClass('active');
    } else if(
      year === 'undefined' &&
      word === 'undefined' &&
      company === 'undefined' &&
      category === 'undefined'
    ) {
      sortText.html('');
      sortText.removeClass('active');
    }
  }


  const sortText = $('.newsSortText'),
        listArea = $('.newsListArea'),
        url = new URL(window.location.href),
        params = new URL(window.location.href).searchParams;
  let year,
      word,
      company,
      category,
      paged,
      beforePaged,
      noMoreArticles,
      scroll = $(window).scrollTop(),
      loadPoint = listArea.offset().top + listArea.outerHeight() - $(window).height();

  // ページ訪問時、自動的に絞り込みを動作させる
  if( params.get('current-cat') === 'ir情報' ) {
    year = 'undefined';
    word =  'undefined';
    company = 'undefined';
    category = params.get('current-cat');
    paged = 1;
    noMoreArticles = false;
    ajaxLoad( year, word, company, category, paged );

    $('input[name="currentCat"][value="ir%e6%83%85%e5%a0%b1"]' ).click();
    $('input[name="currentCat"]#cat-all').prop('checked', false);
  } else {
    year = 'undefined';
    word =  'undefined';
    company = 'undefined';
    category = 'undefined';
    paged = 1;
    noMoreArticles = false;

    ajaxLoad( year, word, company, category, paged );
  }

  // 年で絞り込んだ際のインタラクション
  $('select.select').on('change', function(){
    $('input[name="searchWord"]').val('');
    $('input[name="currentComAll"]').prop('checked', true);
    $('input[name="currentCom"]').prop('checked', false);
    $('input[name="currentCatAll"]').prop('checked', true);
    $('input[name="currentCat"]').prop('checked', false);

    $('select.select option').each(function(){
      const option = $(this);
      if( option.prop('selected') === true ) {
        if( option.val() !== 'すべて' ) {
          year = option.val();
        } else {
          year = 'undefined';
        }
      }
    });

    word =  'undefined';
    company = 'undefined';
    category = 'undefined';
    paged = 1;
    noMoreArticles = false;

    ajaxLoad( year, word, company, category, paged );

    $('input[name="currentCom"]#com-all').prop('checked', true);
    $('input[name="currentCat"]#cat-all').prop('checked', true);
  });

  // ワードで絞り込んだ際のインタラクション
  $(document).on('keyup', 'input[name="searchWord"]', function(){
    $('option[value="すべて"]').prop('selected', true);
    $('input[name="currentComAll"]').prop('checked', true);
    $('input[name="currentCom"]').prop('checked', false);
    $('input[name="currentCatAll"]').prop('checked', true);
    $('input[name="currentCat"]').prop('checked', false);

    year = 'undefined';

    if( $('input[name="searchWord"]').val() ) {
      word =  $('input[name="searchWord"]').val();
    } else {
      word =  'undefined';
    }

    company = 'undefined';
    category = 'undefined';
    paged = 1;
    noMoreArticles = false;

    ajaxLoad( year, word, company, category, paged );

    $('input[name="currentCom"]#com-all').prop('checked', true);
    $('input[name="currentCat"]#cat-all').prop('checked', true);
  });

  // 会社を『すべて』で絞り込んだ際のインタラクション
  $('input[id="com-all"]').on('change', function(){
    $('option[value="すべて"]').prop('selected', true);

    const input = $(this);

    if( input.prop('checked') === true ) {
      $('input[name="currentCom"]').not('#com-all').prop('checked', false);

      year = 'undefined';
      word = 'undefined';
      company = 'undefined';

      category = '';
      $('input[name="currentCat"]:checked').each(function(){
        category = category + ', ' + $(this).val();
      });
      if( category === '' ) {
        category = 'undefined';
      } else {
        $('input[name="currentCatAll"]').prop('checked', false);
      }

      paged = 1;
      noMoreArticles = false;

      ajaxLoad( year, word, company, category, paged );
    }
  });

  // カテゴリを『すべて』で絞り込んだ際のインタラクション
  $('input[id="cat-all"]').on('change', function(){
    $('option[value="すべて"]').prop('selected', true);

    const input = $(this);

    if( input.prop('checked') === true ) {
      $('input[name="currentCat"]').not('#cat-all').prop('checked', false);

      year = 'undefined';
      word = 'undefined';

      company = '';
      $('input[name="currentCom"]:checked').each(function(){
        company = company + ', ' + $(this).val();
      });
      if( company === '' ) {
        company = 'undefined';
      } else {
        $('input[name="currentComAll"]').prop('checked', false);
      }

      category = 'undefined';
      paged = 1;
      noMoreArticles = false;

      ajaxLoad( year, word, company, category, paged );
    }
  });

  // 会社・カテゴリで絞り込んだ際のインタラクション
  $('input[name="currentCom"], input[name="currentCat"]').on('change', function(){
    $('option[value="すべて"]').prop('selected', true);
    $('input[name="searchWord"]').val('');

    year = 'undefined';
    word =  'undefined';

    company = '';
    $('input[name="currentCom"]:checked').each(function(n){
      if( n === 0 ) {
        company = $(this).val();
      } else {
        company = company + ', ' + $(this).val();
      }
    });
    if( company === '' ) {
      company = 'undefined';
      $('input[name="currentComAll"]').prop('checked', true);
    } else {
      $('input[name="currentComAll"]').prop('checked', false);
    }

    category = '';
    $('input[name="currentCat"]:checked').each(function(n){
      if( n === 0 ) {
        category = $(this).val();
      } else {
        category = category + ', ' + $(this).val();
      }
    });
    if( category === '' ) {
      category = 'undefined';
      $('input[name="currentCatAll"]').prop('checked', true);
    } else {
      $('input[name="currentCatAll"]').prop('checked', false);
    }

    paged = 1;
    noMoreArticles = false;

    ajaxLoad( year, word, company, category, paged );
  });
  $('input[name="currentCom"]').not('#com-all').on('change', function(){
    $('input[name="currentCom"]#com-all').prop('checked', false);
  });
  $('input[name="currentCat"]').not('#cat-all').on('change', function(){
    $('input[name="currentCat"]#cat-all').prop('checked', false);
  });

  // ページの最下部までスクロールした際のインタラクション
  $(window).on("scrollstop", function(){
    if( noMoreArticles === false ) {
      scroll = $(window).scrollTop();
      loadPoint = listArea.offset().top + listArea.outerHeight() - $(window).height();

      if( scroll >= loadPoint ) {
        paged++;

        ajaxLoad( year, word, company, category, paged );
      }
    }
  });
});

// 詳細検索アコーディオン
$(function () {
  $('.btn__detail').click(function(){
    $(this).toggleClass('active');
    $('.searchListItemNone').slideToggle().toggleClass('active');
  });
});